import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button, FormControl, TextField } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { OverlayContext } from '../../../../contextProviders/OverlayContext';
import { AccessDataContext } from '../../../../contextProviders/AccessDataContext';
import { useValidation } from '../../../../hooks/UseValidation';
import envirolabLogo from '../../../../resources/images/Envirolab-family-330x150.png';

const ResetPassword = () => {
  const { setShowLoadingOverlay } = useContext(OverlayContext);
  const { token } = useParams();
  const { validatePassword } = useValidation();
  const { resetPassword } = useContext(AccessDataContext);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [resetSuccessful, setResetSuccessful] = useState(false);
  const [error, setError] = useState(null);

  const submitPasswordReset = useCallback(
    (e) => {
      e.preventDefault();

      const checkPassword = validatePassword(password);
      setPasswordValid(checkPassword);
      if (!passwordsMatch || !checkPassword) {
        return;
      }

      setShowLoadingOverlay(true);

      const data = {
        Token: token,
        Password: password,
        ConfirmPassword: confirmPassword,
      };

      resetPassword(data).then((returnVal) => {
        if (returnVal && returnVal.message && returnVal.message === 'Success') {
          setResetSuccessful(true);
        } else if (returnVal.error === 'Invalid token') {
          setError('Token is invalid. Please submit a new request from the login page');
        } else if (returnVal.error) {
          setError(returnVal.error);
        }
        setShowLoadingOverlay(false);
      });
    },
    [setShowLoadingOverlay, resetPassword, token, password, confirmPassword, passwordsMatch, validatePassword]
  );

  useEffect(() => {
    setPasswordsMatch(password === confirmPassword);
  }, [password, confirmPassword, setPasswordsMatch]);

  useEffect(() => {
    if (!passwordValid) {
      setPasswordValid(validatePassword(password));
    }
  }, [password, validatePassword, passwordValid]);

  return (
    <Box id="loginBox">
      <Box className="imageBox">
        <img alt="Envirolab logo" src={envirolabLogo} />
      </Box>

      <h1>Set New Password</h1>

      {!resetSuccessful ? (
        <form onSubmit={submitPasswordReset}>
          <FormControl fullWidth>
            <TextField
              label="Password"
              type="password"
              name="password"
              error={!passwordValid}
              helperText={
                !passwordValid ? 'Minimum six characters, at least one uppercase letter, one lowercase letter and one number' : ''
              }
              onChange={(item) => setPassword(item.target.value)}
              required
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              label="Confirm Password"
              type="password"
              name="confirmPassword"
              error={!passwordsMatch}
              helperText={!passwordsMatch ? 'Passwords do not match' : ''}
              onChange={(item) => setConfirmPassword(item.target.value)}
              required
            />
          </FormControl>

          <Button className="siteBtn" type="submit" variant="outlined" size="large">
            Submit
          </Button>

          {error ? <Box className="errorBox">{error}</Box> : null}
        </form>
      ) : (
        <Box className="successBox">
          Password has been changed. Please click <Link to="/">here</Link> to login
        </Box>
      )}
    </Box>
  );
};

export default ResetPassword;
